import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const gatewayAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.SSO_HOST_URL as string,
});

setupInterceptors(gatewayAxiosInstance);

export default gatewayAxiosInstance;
